import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservablesService {
    private totalCarrito_ob: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    totalCarrito: Observable<number> = this.totalCarrito_ob.asObservable();

    private carrito_ob: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    carrito: Observable<any> = this.carrito_ob.asObservable();

    private precioCarrito_ob: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    precioCarrito: Observable<number> = this.precioCarrito_ob.asObservable();

    private logueado_obj: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    logueado: Observable<boolean> = this.logueado_obj.asObservable();

    constructor() { }

    updateCarrito(carrito: any){
        this.carrito_ob.next(carrito);
        this.totalCarrito_ob.next(carrito.length);

        var totalPrecio = 0;
        if(carrito && carrito.length > 0)
        carrito.forEach((element:any) => {
            if(element.reparaciones){
                for(var i = 0; i<element.reparaciones.length; i++){
                    if(element.reparaciones[i].precio && element.reparaciones[i].precio > 0){
                        totalPrecio += (element.reparaciones[i].precio*element.reparaciones[i].cantidad);
                    }
                }
            }
        });
        
        this.precioCarrito_ob.next(Math.round(totalPrecio * 100) / 100);
    }

    setLogueado(logueado: boolean){
        this.logueado_obj.next(logueado);
    }
}
